export { DMS_MODULE } from '../constants';
export const NAME = 'ZakazkaZaloha';
export const CRUMB_LABEL_KEY = 'edtZakZaloha';

export const POLOZKY = 'Polozky';

export const enum PolozkaStatus {
	unmodified = 0,
	inserted = 1,
	modified = 2,
	deleted = 3
}
